import { staticGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as z from "zod/v4";

export const updateStaticSegment = {
  name: "updateStaticSegment" as const,
  input: z.object({ _id: z.string(), name: z.string().min(1) }),
  output: staticGroupSchema,
};
